class elementDrawing {
	
	constructor()
	{
		this.currentUserData = JSON.parse(localStorage.getItem("userData"));
		this.canvasRatio = 1280 / 1000;
		this.canvasW = 1280;
		this.canvasH = 720;
		
		if ( window['preStreamingWhite'] )
			{
				this.canvasRatio = window.$('#local-media').width() / 1000;
				this.canvasW = window.$('#local-media').width();
				this.canvasH = window.$('#local-media').height();
			}
			
		this.circleRotate = 0;
		this.circleOpacity = 0.5;
		this.secondCircleOpacity = 0.5;
		this.increaseOpacity = true;
		this.increaseSecondOpacity = true;
		this.rectOpacity = 0.5;
		this.secondRectOpacity = 0.5;
		this.increaseOpacityRect = true;
		this.increaseSecondOpacityRect = true;
		this.moveCircle = 50*this.canvasRatio;
		this.moveCircleTop = 10*this.canvasRatio;
		this.secondCircle = 50*this.canvasRatio;
		this.secondCircleTop = 10*this.canvasRatio;
		this.moveRect = 0;
		this.moveRectTop = 0;
		this.secondRect = 0;
		this.secondRectTop = 0;
		this.circleColor = 'rgb(155, 81, 224, 0.5)';
		this.secondCircleColor = 'rgb(0, 170, 0, 0.5)';
		this.rectColor = 'rgb(155, 81, 224, 0.5)';
		this.secondRectColor = 'rgb(0, 170, 0, 0.5)';
		this.circleStepColor = 'rgba(42, 163, 46, 0.7)';
		this.startSecondCircle = false;
		this.standInSpace = false;
		this.arrowPos = 75*this.canvasRatio;
		this.arrowGap = 50*this.canvasRatio;
		this.increaseArrowGap = true;
		this.whiteboardValues = this.currentUserData.whiteboardValues;
	}
	
	standSpace(id, ctx, spaceElements, type, stand, dist) {
		var canvasRatio = this.canvasRatio;
		if ( this.rectOpacity >= 0.5 && this.increaseOpacityRect ) { this.rectOpacity += 0.03; }
		if ( this.rectOpacity >= 1 ) { this.increaseOpacityRect = false; }
		if ( !this.increaseOpacityRect ) { this.rectOpacity -=0.03; }
		
		//if ( (this.moveRect <= 50*canvasRatio ) ) { this.moveRect -= 2*canvasRatio; this.moveRectTop -= 0.4*canvasRatio; if ( this.moveRect <= 0 ) { if ( !this.startsecondRect ) { this.startsecondRect = true; } } if ( this.moveRect <= -50*canvasRatio ){ this.moveRect = 50*canvasRatio; this.moveRectTop = 10*canvasRatio; this.rectOpacity = 0.5; this.increaseOpacityRect = true;} }
		if ( (this.moveRect <= 0 ) ) { this.moveRect -= 1*canvasRatio; this.moveRectTop -= 0.2*canvasRatio; if ( this.moveRect <= -12.5*canvasRatio ) { if ( !this.startsecondRect ) { this.startsecondRect = true; } } if ( this.moveRect <= -25*canvasRatio ){ this.moveRect = 0; this.moveRectTop = 0; this.rectOpacity = 0.5; this.increaseOpacityRect = true;} }
		
		//this.standInSpace = stand;
		this.rectColor = 'rgb(36, 34, 61, '+this.rectOpacity+')';
		
		var moveSpace = 0;
		var moveSpaceTop = 0;
		
		if ( stand ) { moveSpace = 0; this.rectColor = 'rgba(36, 34, 61, 1)'; this.moveRectTop = 0; this.moveRect = -12.5; this.secondRect = 0; this.secondRectTop = 0; this.rectOpacity = 0.75; this.secondRectOpacity = 0.5; this.increaseOpacityRect = false; this.increaseSecondOpacityRect = true;}
		
		/* this.circleLeftSide = spaceElements['leftSideOfSpace'];
		this.circleRightSide = spaceElements['rightSideOfSpace'];
		
		var circleWidth = spaceElements['rightSideOfSpace']-spaceElements['leftSideOfSpace'];
		var circleHeight = spaceElements['bottomSide']-spaceElements['topSide'];
		var circleRadiusX = (circleWidth-this.moveRect)/2 >= 1 ? (circleWidth-this.moveRect)/2 : 1;
		var circleRadiusY = (circleHeight-this.moveRectTop)/2 >= 1 ? (circleHeight-this.moveRectTop)/2 : 1;
		this.circleWidth = circleWidth; */
		
		ctx.beginPath();
		ctx.moveTo(spaceElements['moveX'] + (this.moveRect*dist), spaceElements['moveY'] + (this.moveRectTop*dist));
		ctx.lineTo(spaceElements['line1X'] + (this.moveRect*dist), spaceElements['line1Y'] - (this.moveRectTop*dist));
		ctx.lineTo(spaceElements['line2X'] - (this.moveRect*dist), spaceElements['line2Y'] - (this.moveRectTop*dist));
		ctx.lineTo(spaceElements['line3X'] - (this.moveRect*dist), spaceElements['line3Y'] + (this.moveRectTop*dist));
		ctx.lineTo(spaceElements['moveX'] + (this.moveRect*dist), spaceElements['line3Y'] + (this.moveRectTop*dist));
		ctx.lineWidth = spaceElements['lineWidth'];
		ctx.lineCap = 'round';
		
		if ( stand )
			{
				ctx.strokeStyle = this.rectColor;
				ctx.stroke();
			}
		else
			{
				ctx.fillStyle = this.rectColor;
				ctx.fill();
			}
		
		ctx.closePath();
		
		if ( this.startsecondRect && !stand )
			{
				if ( this.secondRectOpacity >= 0.5 && this.increaseSecondOpacityRect ) { this.secondRectOpacity += 0.03; }
				if ( this.secondRectOpacity >= 1 ) { this.increaseSecondOpacityRect = false; }
				if ( !this.increaseSecondOpacityRect ) { this.secondRectOpacity -= 0.03; }							
				
				//if ( (this.secondRect <= 50*canvasRatio ) ) { this.secondRect -= 2*canvasRatio; this.secondRectTop -= 0.4*canvasRatio; if ( this.secondRect <= -50*canvasRatio ){ this.secondRect = 50*canvasRatio; this.secondRectTop = 10*canvasRatio; this.secondRectOpacity = 0.5; this.increaseSecondOpacityRect = true;} }
				if ( (this.secondRect <= 0 ) ) { this.secondRect -= 1*canvasRatio; this.secondRectTop -= 0.2*canvasRatio; if ( this.secondRect <= -25*canvasRatio ){ this.secondRect = 0; this.secondRectTop = 0; this.secondRectOpacity = 0.5; this.increaseSecondOpacityRect = true;} }
				
				this.secondRectColor = 'rgb(36, 34, 61, '+this.secondRectOpacity+')';
				/* var secondRectRadiusX = (circleWidth-this.secondRect)/2 >= 1 ? (circleWidth-this.secondRect)/2 : 1;
				var secondRectRadiusY = (circleHeight-this.secondRectTop)/2 >= 1 ? (circleHeight-this.secondRectTop)/2 : 1; */
				ctx.beginPath();
				ctx.moveTo(spaceElements['moveX'] + (this.secondRect*dist), spaceElements['moveY'] + (this.secondRectTop*dist));
				ctx.lineTo(spaceElements['line1X'] + (this.secondRect*dist), spaceElements['line1Y'] - (this.secondRectTop*dist));
				ctx.lineTo(spaceElements['line2X'] - (this.secondRect*dist), spaceElements['line2Y'] - (this.secondRectTop*dist));
				ctx.lineTo(spaceElements['line3X'] - (this.secondRect*dist), spaceElements['line3Y'] + (this.secondRectTop*dist));
				ctx.lineTo(spaceElements['moveX'] + (this.secondRect*dist), spaceElements['line3Y'] + (this.secondRectTop*dist));
				ctx.lineWidth = spaceElements['lineWidth'];
				ctx.fillStyle = this.secondRectColor;
				ctx.fill();
				ctx.closePath();
			}
			
		if ( !stand )
			{
				ctx.beginPath();
				ctx.moveTo((spaceElements['moveX']+(this.whiteboardValues.ladderActiveZoneWidth/5)*dist), (spaceElements['moveY']+(this.whiteboardValues.ladderActiveZoneHeight/5)*dist));
				ctx.lineTo((spaceElements['line1X']+(this.whiteboardValues.ladderActiveZoneWidth/4)*dist), (spaceElements['line1Y']-(this.whiteboardValues.ladderActiveZoneHeight/5)*dist));
				ctx.lineTo((spaceElements['line2X']-(this.whiteboardValues.ladderActiveZoneWidth/4)*dist), (spaceElements['line2Y']-(this.whiteboardValues.ladderActiveZoneHeight/5)*dist));
				ctx.lineTo((spaceElements['line3X']-(this.whiteboardValues.ladderActiveZoneWidth/5)*dist), (spaceElements['line3Y']+(this.whiteboardValues.ladderActiveZoneHeight/5)*dist));
				ctx.lineTo((spaceElements['moveX']+(this.whiteboardValues.ladderActiveZoneWidth/5)*dist), (spaceElements['line3Y']+(this.whiteboardValues.ladderActiveZoneHeight/5)*dist));
				ctx.fillStyle = 'rgb(155, 81, 224)';
				ctx.fill();
				ctx.closePath();
			}
		
		this.clearUpElement(spaceElements['line1X']-25*canvasRatio, spaceElements['moveY']-10*canvasRatio, (spaceElements['line2X']-spaceElements['line1X'])+50*canvasRatio, (spaceElements['line2Y']-spaceElements['moveY'])+20*canvasRatio, true);
	}
	
	mainLineDraw(ctx, bagLineStructure) {
		ctx.beginPath();
		ctx.moveTo(bagLineStructure['moveX'], bagLineStructure['moveY']);
		ctx.lineTo(bagLineStructure['lineX'], bagLineStructure['lineY']);
		ctx.lineWidth = bagLineStructure['lineWidth'];
		ctx.lineCap = bagLineStructure['lineCap'] ? bagLineStructure['lineCap'] : "round";
		ctx.strokeStyle = bagLineStructure['strokeColor'];
		ctx.stroke();
		ctx.closePath();
	}
	
	curvedLineDraw(ctx, bagLineStructure, drawArrows, id) {
		let lineHeight = bagLineStructure['moveY'] - bagLineStructure['lineY'];
		let lineWidth = bagLineStructure['moveX'] - bagLineStructure['lineX'];
		ctx.beginPath();
		ctx.lineCap = 'butt';
		ctx.moveTo(bagLineStructure['moveX'], bagLineStructure['moveY']);
		//ctx.quadraticCurveTo(bagLineStructure['moveX'], bagLineStructure['moveY'] - lineHeight/2, bagLineStructure['lineX'], bagLineStructure['lineY']);
		ctx.bezierCurveTo(bagLineStructure['moveX'], bagLineStructure['moveY'] - lineHeight/5, bagLineStructure['moveX'] - lineWidth/2, bagLineStructure['lineY'] + lineHeight/5, bagLineStructure['lineX'], bagLineStructure['lineY']);
		ctx.lineCap = 'butt';
		ctx.lineWidth = bagLineStructure['lineWidth'];
		ctx.strokeStyle = bagLineStructure['strokeColor'];
		ctx.stroke();
		ctx.closePath();
		
		let move1 = bagLineStructure['side'] ? -25 : 25;
		let move2 = bagLineStructure['side'] ? -25 : 25;
		let move3 = bagLineStructure['side'] ? -25 : 25;
		let move4 = bagLineStructure['side'] ? -10 : 10;
		
		let move5 = bagLineStructure['side'] ? 7 : -7;
		let move6 = bagLineStructure['side'] ? 12 : -12;
		let move7 = bagLineStructure['side'] ? 7 : -7;
		let move8 = bagLineStructure['side'] ? 30 : -30;
		
		let move9 = bagLineStructure['side'] ? 7 : -7;
		let move10 = bagLineStructure['side'] ? 12 : -12;
		let move11 = bagLineStructure['side'] ? 7 : -7;
		let move12 = bagLineStructure['side'] ? 30 : -30;
		
		let moveLineWidth = -(lineWidth/2);
		
		if ( ( !window['guestUser'] && window['boxJumpWidth'+id] == 49 ) || ( window['guestUser'] && window['boxJumpWidth'] == 49 ) ) { window['lineSizeTop'] = 14; window['lineSizeBottom'] = -4 }
		if ( ( !window['guestUser'] && window['boxJumpWidth'+id] == 70 ) || ( window['guestUser'] && window['boxJumpWidth'] == 70 ) ) { window['lineSizeTop'] = 16; window['lineSizeBottom'] = -2 }
		if ( ( !window['guestUser'] && window['boxJumpWidth'+id] == 84 ) || ( window['guestUser'] && window['boxJumpWidth'] == 84 ) ) { window['lineSizeTop'] = 17; window['lineSizeBottom'] = 1 }
		if ( ( !window['guestUser'] && window['boxJumpWidth'+id] == 98 ) || ( window['guestUser'] && window['boxJumpWidth'] == 98 ) ) { window['lineSizeTop'] = 15; window['lineSizeBottom'] = 1 }
		if ( ( !window['guestUser'] && window['boxJumpWidth'+id] == 112 ) || ( window['guestUser'] && window['boxJumpWidth'] == 112 ) ) { window['lineSizeTop'] = 15; window['lineSizeBottom'] = 5 }
		
		if ( drawArrows )
			{
				ctx.beginPath();
				/* ctx.moveTo(bagLineStructure['moveX'] + move1 * bagLineStructure['dist'], bagLineStructure['moveY'] - 50 * bagLineStructure['dist']);
				ctx.lineTo(bagLineStructure['moveX'] + move2 * bagLineStructure['dist'], bagLineStructure['moveY'] - 35 * bagLineStructure['dist']);
				ctx.moveTo(bagLineStructure['moveX'] + move3 * bagLineStructure['dist'], bagLineStructure['moveY'] - 50 * bagLineStructure['dist']);
				ctx.lineTo(bagLineStructure['moveX'] + move4 * bagLineStructure['dist'], bagLineStructure['moveY'] - 40 * bagLineStructure['dist']); */
				
				/* ctx.moveTo(bagLineStructure['moveX'] + moveLineWidth + move5 * bagLineStructure['dist'], bagLineStructure['moveY'] - lineHeight/3 - 50 * bagLineStructure['dist']);
				ctx.lineTo(bagLineStructure['moveX'] + moveLineWidth + move6 * bagLineStructure['dist'], bagLineStructure['moveY'] - lineHeight/3 - 35 * bagLineStructure['dist']);
				ctx.moveTo(bagLineStructure['moveX'] + moveLineWidth + move7 * bagLineStructure['dist'], bagLineStructure['moveY'] - lineHeight/3 - 50 * bagLineStructure['dist']);
				ctx.lineTo(bagLineStructure['moveX'] + moveLineWidth + move8 * bagLineStructure['dist'], bagLineStructure['moveY'] - lineHeight/3 - 45 * bagLineStructure['dist']); */
				
				ctx.moveTo(bagLineStructure['moveX'] - lineWidth, bagLineStructure['lineY']);
				ctx.lineTo(bagLineStructure['moveX'] - lineWidth + move10 * bagLineStructure['dist'], bagLineStructure['lineY'] + window['lineSizeTop'] * bagLineStructure['dist']);
				ctx.moveTo(bagLineStructure['moveX'] - lineWidth, bagLineStructure['lineY']);
				ctx.lineTo(bagLineStructure['moveX'] - lineWidth + move12 * bagLineStructure['dist'], bagLineStructure['lineY'] + window['lineSizeBottom'] * bagLineStructure['dist']);
				
				ctx.lineCap = 'round';
				ctx.strokeStyle = 'rgb(188, 164, 255)';
				ctx.stroke();
				ctx.closePath();
			}
	}
	
	writeText(ctx, textStructure) {
		ctx.font = textStructure['font'];
		ctx.lineWidth = textStructure['lineWidth'];
		
		let textStartX = textStructure['startX'];
		
		if ( window['guestUser'] || window['onDemand'] )
			{
				ctx.save();
				ctx.translate(1280, 0);
				ctx.scale(-1, 1);
				
				textStartX = 1280 - textStartX;
			}
		
		if ( textStructure['strokeColor'] )
			{
				ctx.strokeStyle = textStructure['strokeColor'];
				ctx.strokeText(textStructure['text'], textStartX, textStructure['startY']);
			}
		
		if ( textStructure['fillStyle'] )
			{
				ctx.fillStyle = textStructure['fillStyle'];
				ctx.fillText(textStructure['text'], textStartX, textStructure['startY']);
			}
		
		if ( window['guestUser'] || window['onDemand'] )
			{
				ctx.restore();
			}
	}
	
	
	personCircle(id, ctx, circleInfo)
		{
			if ( this.standInSpace || circleInfo['x'] == 0 || circleInfo['y'] == 0 ) { return false; }
			if ( this.circleRotate < circleInfo['w']*0.75 ) { this.circleRotate += circleInfo['w']*0.02; }
			else { this.circleRotate = 0; }
			
			ctx.beginPath();
			ctx.lineDashOffset = this.circleRotate;
			ctx.setLineDash([circleInfo['w']/2, circleInfo['w']/4]);
			ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
			ctx.lineWidth = 5*this.canvasRatio;
			ctx.ellipse(circleInfo['x'], circleInfo['y'], circleInfo['w'], circleInfo['h'], 0, 0, Math.PI*2);
			ctx.stroke();
			ctx.setLineDash([]);
			ctx.closePath();
			
			
			this.clearUpElement(circleInfo['x']-circleInfo['w']-10, circleInfo['y']-circleInfo['h']-10, circleInfo['w']+20, circleInfo['h']+20, true);
		}
	
	
	targetCircle(id, ctx, inSpaceCheck, standInSpace, newDesign, greenCircle, boxCircleColor, stopAnimation)
		{
			var canvasRatio = this.canvasRatio;
			if ( this.circleOpacity >= 0.5 && this.increaseOpacity ) { this.circleOpacity += 0.03; }
			if ( this.circleOpacity >= 1 ) { this.increaseOpacity = false; }
			if ( !this.increaseOpacity ) { this.circleOpacity -=0.03; }
			
			if ( (this.moveCircle <= 50*canvasRatio ) ) { this.moveCircle -= 2*canvasRatio; this.moveCircleTop -= 0.4*canvasRatio; if ( this.moveCircle <= 0 ) { if ( !this.startSecondCircle ) { this.startSecondCircle = true; } } if ( this.moveCircle <= -50*canvasRatio ){ this.moveCircle = 50*canvasRatio; this.moveCircleTop = 10*canvasRatio; this.circleOpacity = 0.5; this.increaseOpacity = true;} }
			
			//moveSquatArrow = 30; 
			this.standInSpace = standInSpace;
			this.circleColor = 'rgb(155, 81, 224, '+this.circleOpacity+')';
			if ( newDesign ) { this.circleColor = 'rgb(36, 34, 61, '+this.circleOpacity+')'; }
			//if ( standInSpace ) { this.circleColor = 'rgba(36, 34, 61, 1)'; this.moveCircleTop = 0; this.moveCircle = 0; this.secondCircle = 50*canvasRatio; this.secondCircleTop = 10*canvasRatio; this.circleOpacity = 0.75; this.secondCircleOpacity = 0.5; this.increaseOpacity = false; this.increaseSecondOpacity = true;}
			this.circleStepColor = boxCircleColor;
			
			this.circleLeftSide = inSpaceCheck['leftSideOfSpace'];
			this.circleRightSide = inSpaceCheck['rightSideOfSpace'];
			
			var circleWidth = inSpaceCheck['rightSideOfSpace']-inSpaceCheck['leftSideOfSpace'];
			var circleHeight = inSpaceCheck['bottomSide']-inSpaceCheck['topSide'];
			var circleRadiusX = (circleWidth-this.moveCircle)/2 >= 1 ? (circleWidth-this.moveCircle)/2 : 1;
			var circleRadiusY = (circleHeight-this.moveCircleTop)/2 >= 1 ? (circleHeight-this.moveCircleTop)/2 : 1;
			this.circleWidth = circleWidth;
			ctx.beginPath();
			//ctx.ellipse((inSpaceCheck['leftSideOfSpace']+circleWidth/2), (inSpaceCheck['topSide']+circleHeight/2), circleRadiusX, circleRadiusY, 0, 0, Math.PI*2);
			if ( standInSpace )
				{
					circleRadiusX = (circleWidth)/2 >= 1 ? (circleWidth)/2 : 1;
					circleRadiusY = (circleHeight)/2 >= 1 ? (circleHeight)/2 : 1;
					ctx.ellipse((inSpaceCheck['leftSideOfSpace']+circleWidth/2), (inSpaceCheck['topSide']+circleHeight/2), circleRadiusX, circleRadiusY, 0, 0, Math.PI*2);
					if ( !greenCircle )
						{
							this.circleColor = 'rgb(36, 34, 61)';
							
							ctx.lineWidth = 10*canvasRatio;
							ctx.strokeStyle = this.circleColor;
							ctx.stroke();
						}
					else
						{
							if ( window['globalActType'] == 'reactionDrill' )
								{
									ctx.fillStyle = this.circleColor;
									ctx.fill();
									standInSpace = false;
								}
							else
								{
									ctx.fillStyle = this.circleStepColor;
									ctx.fill();
								}
						}
				}
			else
				{
					let insideCircleColor = this.circleColor;
					if ( stopAnimation )
						{
							circleRadiusX = (circleWidth)/2 >= 1 ? (circleWidth)/2 : 1;
							circleRadiusY = (circleHeight)/2 >= 1 ? (circleHeight)/2 : 1;
							insideCircleColor = 'rgb(36, 34, 61)';
						}
						
					ctx.ellipse((inSpaceCheck['leftSideOfSpace']+circleWidth/2), (inSpaceCheck['topSide']+circleHeight/2), circleRadiusX, circleRadiusY, 0, 0, Math.PI*2);
					ctx.fillStyle = insideCircleColor;
					ctx.fill();
				}
			ctx.closePath();
			
			if ( this.startSecondCircle && !standInSpace )
				{
					if ( this.secondCircleOpacity >= 0.5 && this.increaseSecondOpacity ) { this.secondCircleOpacity += 0.03; }
					if ( this.secondCircleOpacity >= 1 ) { this.increaseSecondOpacity = false; }
					if ( !this.increaseSecondOpacity ) { this.secondCircleOpacity -= 0.03; }							
					
					if ( (this.secondCircle <= 50*canvasRatio ) ) { this.secondCircle -= 2*canvasRatio; this.secondCircleTop -= 0.4*canvasRatio; if ( this.secondCircle <= -50*canvasRatio ){ this.secondCircle = 50*canvasRatio; this.secondCircleTop = 10*canvasRatio; this.secondCircleOpacity = 0.5; this.increaseSecondOpacity = true;} }
					this.secondCircleColor = 'rgb(155, 81, 224, '+this.secondCircleOpacity+')';
					if ( newDesign ) { this.secondCircleColor = 'rgb(36, 34, 61, '+this.secondCircleOpacity+')'; }
					var secondCircleRadiusX = (circleWidth-this.secondCircle)/2 >= 1 ? (circleWidth-this.secondCircle)/2 : 1;
					var secondCircleRadiusY = (circleHeight-this.secondCircleTop)/2 >= 1 ? (circleHeight-this.secondCircleTop)/2 : 1;
					let nowAnimatedColor = this.secondCircleColor;
					if ( stopAnimation )
						{
							secondCircleRadiusX = (circleWidth)/2 >= 1 ? (circleWidth)/2 : 1;
							secondCircleRadiusY = (circleHeight)/2 >= 1 ? (circleHeight)/2 : 1;
							nowAnimatedColor = 'rgb(36, 34, 61)';
						}
					
					ctx.beginPath();
					ctx.ellipse((inSpaceCheck['leftSideOfSpace']+circleWidth/2), (inSpaceCheck['topSide']+circleHeight/2), secondCircleRadiusX, secondCircleRadiusY, 0, 0, Math.PI*2);
					ctx.fillStyle = nowAnimatedColor;
					ctx.fill();
					ctx.closePath();
				}
				
			if ( newDesign && !standInSpace )
				{
					/* ctx.beginPath();
					ctx.ellipse((inSpaceCheck['leftSideOfSpace']+circleWidth/2), (inSpaceCheck['topSide']+circleHeight/2), circleWidth/3, circleHeight/3, 0, 0, Math.PI*2);
					ctx.fillStyle = 'rgb(36, 34, 61)';
					ctx.fill();
					ctx.closePath(); */
					
					ctx.beginPath();
					ctx.ellipse((inSpaceCheck['leftSideOfSpace']+circleWidth/2), (inSpaceCheck['topSide']+circleHeight/2), circleWidth/4, circleHeight/4, 0, 0, Math.PI*2);
					if ( window['globalActType'] == 'reactionDrill' )
						{
							if ( !greenCircle ) { ctx.fillStyle = 'rgb(155, 81, 224)'; }
							else { ctx.fillStyle = this.circleStepColor; }
						}
					else
						{
							ctx.fillStyle = 'rgb(155, 81, 224)';
						}
					ctx.fill();
					ctx.closePath();
				}
			
			this.clearUpElement(inSpaceCheck['leftSideOfSpace']-50*canvasRatio, inSpaceCheck['topSide']-10*canvasRatio, circleWidth+70*canvasRatio, circleHeight+10*canvasRatio, true);
		}
	
	staticCircle(ctx, x1, x2, y1, y2)
		{
			var circleWidth = x2 - x1;
			var circleHeight = y2 - y1;
			
			ctx.beginPath();
			ctx.ellipse(x1 + circleWidth/2, y1 + circleHeight/2, circleWidth/2, circleHeight/2, 0, 0, Math.PI*2);
			ctx.fillStyle = 'rgb(36, 34, 61)';
			ctx.fill();
			ctx.closePath();
		}
	
	staticCircle(ctx, x1, x2, y1, y2)
		{
			var circleWidth = x2 - x1;
			var circleHeight = y2 - y1;
			
			ctx.beginPath();
			ctx.ellipse(x1 + circleWidth/2, y1 + circleHeight/2, circleWidth/2, circleHeight/2, 0, 0, Math.PI*2);
			ctx.fillStyle = 'rgb(36, 34, 61)';
			ctx.fill();
			ctx.closePath();
		}
	
	drawArrows(id, ctx, x, y, arrowSide, arrowHeight, arrowPos, maxGap, skipStep, boxing, hideArrowLine, circleCenter, circleTop, distance)
		{	
			var canvasRatio = this.canvasRatio;
			arrowHeight = arrowHeight*canvasRatio;
			maxGap = maxGap*canvasRatio;
			if ( !skipStep )
				{
					if ( this.arrowGap >= maxGap ) { this.increaseArrowGap = false; }
					if ( this.arrowGap <= maxGap/2 ) { this.increaseArrowGap = true; }
					if ( this.increaseArrowGap ) { this.arrowGap += maxGap/50; }
					else { this.arrowGap -= maxGap/50; }
				}
			
			var arrowGapNew = this.arrowGap;
			var arrowLineX = this.canvasW-x;
			var boxingArrowStart = window['guestUser'] ? 2.5 : 2.8;
			var arrowLineWidth = 10*canvasRatio;
			var rotateAngle = 15;
			var newArrowPos = this.arrowPos;
			if ( boxing ) { rotateAngle = 15 }
			this.arrowPos = arrowPos*canvasRatio;
			if ( arrowSide == 'left' )
				{
					arrowGapNew = this.arrowGap*-1;
					rotateAngle = rotateAngle*-1;
					this.arrowPos = -Math.abs(this.arrowPos);
					//arrowLineX = x+this.circleWidth;
				}
			else
				{
					this.arrowPos = Math.abs(this.arrowPos);
				}
			
			if ( boxing )
				{
					var cirWidth = this.circleRightSide - this.circleLeftSide;
					//console.log(cirWidth, 'cirWidth');
					//arrowLineX = arrowSide == 'left' ? x+this.circleWidth/boxingArrowStart : x-this.circleWidth/boxingArrowStart;
					if ( window['boxingType'] !== 'fourtyFiveDegrees' && window['boxingTypeHost'+id] !== 'fourtyFiveDegrees' ) { arrowLineX = arrowSide == 'left' ? this.circleRightSide : this.circleLeftSide; }
					else { arrowLineX = arrowSide == 'left' ? this.circleRightSide-(cirWidth*0.20): this.circleLeftSide+(cirWidth*0.20); }
					
					//arrowLineX = arrowSide == 'left' ? x+this.circleWidth/2+rotateAngle*canvasRatio: x-this.circleWidth/2+rotateAngle*canvasRatio;
					arrowLineWidth = arrowLineWidth*distance;
					
					newArrowPos = 0;
					if ( ( window['boxingType'] == 'fourtyFiveDegrees' && window['guestUser'] ) || ( window['boxingTypeHost'+id] == 'fourtyFiveDegrees' && !window['guestUser'] ) )
						{
							ctx.save();
							ctx.translate( circleCenter, circleTop );
							ctx.rotate(rotateAngle * Math.PI / 180);
							ctx.translate( -circleCenter, -circleTop );
						}
				}
			
			if ( !hideArrowLine )
				{
					ctx.beginPath();
					ctx.moveTo(x+this.arrowPos, y);
					ctx.lineTo(arrowLineX, y);
					ctx.lineWidth = arrowLineWidth;
					ctx.lineCap = "round";
					//ctx.strokeStyle = 'rgba(64, 136, 149, 1)';
					ctx.strokeStyle = 'rgba(36, 34, 61, 1)';
					ctx.stroke();
					ctx.closePath();
				}
			
			if ( boxing )
				{
					ctx.beginPath();
					ctx.moveTo(x, y-arrowHeight);
					ctx.lineTo(x+this.arrowPos, y);
					ctx.lineTo(x, y+arrowHeight);
					ctx.lineWidth = arrowLineWidth;
					ctx.lineCap = "round";
					//ctx.strokeStyle = 'rgba(64, 136, 149, 1)';
					ctx.strokeStyle = 'rgba(36, 34, 61, 1))';
					ctx.stroke();
					ctx.closePath();
				}
			
			ctx.beginPath();
			ctx.moveTo(x+arrowGapNew+newArrowPos, y-arrowHeight);
			ctx.lineTo(x+this.arrowPos+arrowGapNew+newArrowPos, y);
			ctx.lineTo(x+arrowGapNew+newArrowPos, y+arrowHeight);
			ctx.lineWidth = arrowLineWidth;
			ctx.lineCap = "round";
			//ctx.strokeStyle = 'rgba(64, 136, 149, 0.5)';
			ctx.strokeStyle = 'rgb(36, 34, 61, 0.5)';
			ctx.stroke();
			ctx.closePath();
			
			ctx.beginPath();
			ctx.moveTo(x+arrowGapNew*2+newArrowPos, y-arrowHeight);
			ctx.lineTo(x+this.arrowPos+arrowGapNew*2+newArrowPos, y);
			ctx.lineTo(x+arrowGapNew*2+newArrowPos, y+arrowHeight);
			ctx.lineWidth = arrowLineWidth;
			ctx.lineCap = "round";
			//ctx.strokeStyle = 'rgba(64, 136, 149, 0.25)';
			ctx.strokeStyle = 'rgba(36, 34, 61, 0.25)';
			ctx.stroke();
			ctx.closePath();
			
			if ( boxing )
				{
					if ( ( window['boxingType'] == 'fourtyFiveDegrees' && window['guestUser'] ) || ( window['boxingTypeHost'+id] == 'fourtyFiveDegrees' && !window['guestUser'] ) ) { ctx.restore(); }
				}
		}
		
	drawWorkoutArrows(id, ctx, startX, startY, endX, endY, arrowSide, arrowHeight, arrowPos, arrowGap)
		{
			let arrowNumber = 6;
			
			if ( endX < startX )
				{
					let oldStartX = startX;
					let oldStartY = startY;
					startX = endX;
					startY = endY;
					endX = oldStartX;
					endY = oldStartY;
				}
			
			let startPoint = {'x': startX, 'y': startY};
			let endPoint = {'x': endX, 'y': endY};
			let arrowLength = this.lineDistance(startPoint, endPoint);
			let lengthDiff = arrowLength - (endX - startX);
			
			endX = startX + arrowLength;
			
			let angleStructure = {'x1': endX, 'x2': startX, 'x3': endX - lengthDiff, 'y1': startY, 'y2': startY, 'y3': endY};
			let rotateAngle = this.calculateAngle(angleStructure);
			
			if ( endY < startY )
				{
					rotateAngle = rotateAngle*-1;
				}
			
			/* ctx.beginPath();
			ctx.moveTo(angleStructure['x1'], angleStructure['y1']);
			ctx.lineTo(angleStructure['x2'], angleStructure['y2']);
			ctx.lineTo(angleStructure['x3'], angleStructure['y3']);
			ctx.lineWidth = 10;
			ctx.strokeStyle = 'red';
			ctx.stroke();
			ctx.closePath(); */
			
			if ( arrowSide == 'right' )
				{
					//rotateAngle = rotateAngle*-1;
					arrowPos = arrowPos*-1;
				}
				
			let rotateCenter = startX;
			let rotateTop = startY;
			
			ctx.save();
			ctx.translate( rotateCenter, rotateTop );
			ctx.rotate(rotateAngle * Math.PI / 180);
			ctx.translate( -rotateCenter, -rotateTop );
			
			for ( var i = startX; i <= endX; i += arrowGap )
				{
					let arrowX = i;
					
					ctx.beginPath();
					ctx.moveTo(arrowX, startY-arrowHeight);
					ctx.lineTo(arrowX+arrowPos, startY);
					ctx.lineTo(arrowX, startY+arrowHeight);
					ctx.lineWidth = 5;
					ctx.lineCap = "round";
					ctx.strokeStyle = 'rgb(188, 164, 255)';
					ctx.stroke();
					ctx.closePath();
				}
			
			window['hasEquipment'+id] = true;
			
			ctx.restore();
			this.clearUpElement(startX-Math.abs(arrowPos), startY-arrowHeight*2, endX-startX+Math.abs(arrowPos*2), endY-startY+arrowHeight*4, true);
		}

	lineDistance( point1, point2 )
		{
			var xs = 0;
			var ys = 0;

			xs = point2.x - point1.x;
			xs = xs * xs;

			ys = point2.y - point1.y;
			ys = ys * ys;

			return Math.sqrt( xs + ys );
		}
	
	addRoomSetupCircle(id, whichCircle)
		{
			let roomStartX = whichCircle == 'first' ? this.canvasW/4 - ((this.whiteboardValues.heightCircleW/2)*this.canvasRatio) : this.canvasW - this.canvasW/4 - ((this.whiteboardValues.heightCircleW/2)*this.canvasRatio);
			
			var roomZone = {
				'startX' : roomStartX,
				'startY' : this.canvasH -70*this.canvasRatio-25,
				'w' : this.whiteboardValues.heightCircleW*this.canvasRatio,
				'h' : 70*this.canvasRatio
			};
			
			var roomCircleObj = {
				'cl': "#9b51e0",
				'lineW': "10",
				'rad': (roomZone.startX+roomZone.w - roomZone.startX) * 0.5,
				't': "c",
				'x1': roomZone.startX,
				'x2': roomZone.startX + roomZone.w,
				'y1': roomZone.startY,
				'y2': roomZone.startY + roomZone.h,
				'hidden': true,
				'roomC': true,
				'whichC': whichCircle
			};
			
			for ( var i = 0; i < window['canvasLines'+id].length; i++ )
				{
					if ( window['canvasLines'+id][i]['t'] == 'c' && window['canvasLines'+id][i]['roomC'] )
						{
							window['canvasLines'+id].splice(i, 1);
							
							i--;
						}
				}
			
			window['canvasLines'+id].push(roomCircleObj);
			
			console.log('room circle', window['canvasLines'+id]);
		}
		
	touchedCircle(id, ctx)
		{
			
		}
}

export default elementDrawing;